const Data = [
  {
    date: "07/05/2023",
    title: "React Cart",
    description: `React shopping cart project where users can instantly see price changes as they add items to their cart. Manage product listings, cart state, and dynamically update prices as items are added. This simple e-commerce application`,
    url: "https://car-t.netlify.app/",
    imgSrc: `https://www.codeproject.com/KB/E-commerce/1121533/Cart.png`,
  },

  {
    date: "11/10/2022",
    title: "VIDEO HUB",
    description:
      "This is the sample description about the project details. The more details the more details and evenually more details because I don't have anything to write",
    url: "https://viode-s.netlify.app/",
    imgSrc: `https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqlbylgVjmm40MGKSDuFgsDYunb6qLQF5qEw&usqp=CAU`,
  },
  {
    date: "15/06/2023",
    title: "XCrypto",
    description:
      "This is the sample description about the project details. The more details the more details and evenually more details because I don't have anything to write",
    url: "https://bitcoi-n.netlify.app/",
    imgSrc: `https://reactjsexample.com/content/images/2021/10/A-Crypto-Tracker-Built-with-React-And-Flexbox.jpg`,
  },

  {
    date: "17/04/2023",
    title: "Film rise ",
    description: `• Created a dynamic web platform, FilmRise, using cutting-edge
    technologies including Jsx, Tailwind CSS, and ReactJS and Firebase.
    • Implemented user-friendly features, such as mobile number OTP
    authentication, to ensure secure and seamless user interactions.
    • Empowered users to contribute by adding movies, rating them,
    and leaving comments to foster a vibrant film community.
    • Leveraged Firebase for the backend to enhance scalability and
    real-time data updates.
    • FilmRise represents a passion project that combines my love for
    movies with my technical expertise to deliver an engaging online
    film experience
      
      `,
    url: "https://filmris-e.netlify.app/",
    imgSrc: `https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSq6tHK45OxblwPJh6mA2OPG5gxan6WlfHwU_n1dzoiIpJG6spqkPjv55xEvVOOD8i3MJg&usqp=CAU`,
  },
  {
    date: "20/02/2023",
    title: "Ford",
    description: `Ford Invest is an innovative platform where registered users can
      explore investment plans ranging from 500 to 50,000 INR.
      MY LIFE MY RULES
      “This version maintains the essence of
      self-determination and ambition in a
      more concise manner. .”
      MOST PROUD OF
       First Prize - BCA 6th Semester
      Developed a dynamic online book
      store using HTML, CSS, JavaScript, and
      FireBase.
      • Designed and implemented an interactive
      e-commerce platform for buying and selling books.
      • Demonstrated strong web development
      skills, including front-end and back-end
      development.
      • First place winner in recognition of the
      innovative and user-friendly book store
      project.
      È Silent and Respected Teacher Award
      Recognized for my dedication and impact as an educator.
      • Committed to creating a nurturing and effective learning environment for students.
      • Received the Silent and Respected Teacher
      Award in acknowledgment of my passion
      for teaching.
      ⋆ Brave Student Award
      Honored with the Brave Student
      Award for outstanding courage and
      determination.
      • Demonstrated exceptional resilience and
      bravery in overcoming challenges.
      • The recipient of the Brave Student Award
      for exemplifying courage in pursuit of education.
      SKILLS
      Hard-working Fast Learning
      HTML5 CSS3 JavaScript Boostrap 5
      Tailwind CSS ReactJS NodeJs ExpressJs
      MongoDB Next Js Git GitHub
      • Users who opt for the 350 INR plan can earn 100 INR daily, providing a potential avenue for passive income.
      • Additionally, users have the option to boost their earnings by
      referring friends through a unique referral link.
      • Ford Invest offers a user-friendly investment experience, combining financial opportunities with modern technolog`,
    url: "https://for-d.netlify.app/",
    imgSrc: `https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJsII5kH84FCQgiBZ_E6MoOL0WvskG-EV94Q&usqp=CAU`,
  },
  {
    date: "20/01/2023",
    title: "MI CLONE",
    description: `Created a high-fidelity clone of the Mi website, replicating its
      design and functionality.
      • Leveraged the Mi API to provide real-time product listings and
      details.
      • Ensured responsive design to deliver an optimal user experience
      across devices, from desktop to mobile.
      • The Mi Store Clone project showcases my front-end development skills and attention to detail in recreating a seamless ecommerce platform.
      `,
    url: "https://mi-stor-e.netlify.app/",
    imgSrc: `https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRtmPh2dr6HWjaxSmc43rl5MyHMCxu7XwFK9w&usqp=CAU`,
  },
  {
    date: "20/12/2022",
    title: "WEATHER APP",
    description: `• Developed a user-friendly Weather App that provides real-time
    weather information for cities worldwide.
    • Leveraged the OpenWeather API to access weather data for all
    countries and cities, offering comprehensive coverage.
    • Users can easily check current weather conditions, forecasts, and
    more, making it a valuable tool for planning and travel.
    • The Weather App project showcases my skills in API integration and user interface design, enhancing accessibility to weather
    data`,
    url: "https://weat-he-r.netlify.app/",
    imgSrc: `https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR3D3wqdM-rGtS1oh9dfzxW3eqAjVyznmkZiQ&usqp=CAU`,
  },
];
export default Data;
